import { gql } from "@apollo/client";

const GET_HONORARIO_DETALLE = gql`
query honorarioProfesionalById(
    $idHonorarioProfesional: Int!
) {
    honorarioProfesionalById(idHonorarioProfesional: $idHonorarioProfesional)
    {
        idHonorarioProfesional
        idDelegacion
        descripcion
        idTipoProfesional
        idFormaLiquidacion
        idFiguraProfesional
        idClaseMonitoreo
        valor
        valorVirtual
        valorExtra
        activo
        fechaExpira
        observacion
        t_HonorarioProfesional_TipoModulo{
            idTipoModulo
        }
        honorarioAjusteEnfermeria{
            idTipoAjusteEnfermeria
            valor
        }
    }
}`;

export default GET_HONORARIO_DETALLE;

export const adaptHonorario = (honorario) => {
  return {
    id: honorario?.idHonorarioProfesional,
    idDelegacion: honorario?.idDelegacion,
    descripcion: honorario?.descripcion,
    idTipoProfesional: honorario?.idTipoProfesional,
    idFiguraProfesional: honorario?.idFiguraProfesional,
    idFormaLiquidacion: honorario?.idFormaLiquidacion,
    idClaseMonitoreo: honorario?.idClaseMonitoreo,
    valor: honorario?.valor,
    valorVirtual: honorario?.valorVirtual,
    valorExtra: honorario?.valorExtra,
    activo: honorario?.activo,
    fechaExpira: honorario?.fechaExpira,
    observacion: honorario?.observacion,
    idsTipoModulo: honorario?.t_HonorarioProfesional_TipoModulo?.map((tipoModulo) => tipoModulo.idTipoModulo),
    cambioSonda: honorario?.honorarioAjusteEnfermeria?.find((ajuste) => ajuste.idTipoAjusteEnfermeria === 1)?.valor,
    capacitacion: honorario?.honorarioAjusteEnfermeria?.find((ajuste) => ajuste.idTipoAjusteEnfermeria === 2)?.valor,
    emergencia: honorario?.honorarioAjusteEnfermeria?.find((ajuste) => ajuste.idTipoAjusteEnfermeria === 3)?.valor,
    extraduracion: honorario?.honorarioAjusteEnfermeria?.find((ajuste) => ajuste.idTipoAjusteEnfermeria === 4)?.valor
  };
};